import type { SaveChunksResult } from "@kaleidoscope-solutions/engine-wasm"
import type { ModelFacade } from "@/utils/useEngineModel/ModelFacade"
import { ConfigureModelIntent, ConfigureModelLayers, Layer } from "@kaleidoscope-solutions/engine-wasm"
import { ModelApi } from "@/utils/useEngineModel/ModelApi"

export class ModelSandboxFacade extends ModelApi {
  clear() {
    // Free the memory allocated in the sandbox - note this doesn't affect peak memory of the Wasm module.
    this.api?.loadModelFromYaml("")
  }
}

export async function cloneModelToSandbox(sandbox: ModelSandboxFacade, model: ModelFacade) {
  const baseLayer = await model.api.saveModelLayerToChunks(Layer.Base)
  const orgLayer = await model.api.saveModelLayerToChunks(Layer.Org)
  const userLayer = await model.api.saveModelLayerToChunks(Layer.User)

  const makeIntent = (layer: SaveChunksResult) => ConfigureModelIntent.replaceChunks(layer.chunks, layer.fileNames)

  await sandbox.api.configureModel(new ConfigureModelLayers(makeIntent(baseLayer), makeIntent(orgLayer), makeIntent(userLayer)))
}
